import { FC, PropsWithChildren } from "react";
import cn from "classnames";
import TimeSwitch from "./TimeSwitch";
import { useChart } from "@stores/chart.store";
import { useSwap } from "@stores/swap.store";
import { AssetButton } from "@/components/common/AssetButton";

const ViewHolder: FC<PropsWithChildren> = ({ children }) => {
    // Get the current pair from the chart store
    const { chartData } = useChart();
    const { sellAssetInfo, buyAssetInfo } = useSwap();

    // Determine which assets to display based on the chart data or swap assets
    const displayPair =
        chartData?.pair && chartData.pair.length === 2 ? chartData.pair : [sellAssetInfo.asset, buyAssetInfo.asset];

    // Get the price from the chart data (last point if available)
    const lastPrice = chartData?.chartData?.[chartData.chartData.length - 1]?.close ?? 0;
    const previousPrice = chartData?.chartData?.[chartData.chartData.length - 2]?.close ?? lastPrice;
    const priceChange = lastPrice > 0 && previousPrice > 0 ? ((lastPrice - previousPrice) / previousPrice) * 100 : 0;

    const formattedPrice = lastPrice > 0 ? `$${lastPrice.toFixed(2)}` : "$0.00";
    const formattedPriceChange = priceChange ? `${priceChange.toFixed(2)}%` : "0.00%";

    // Determine which assets to show based on whether the chart is flipped
    const firstAsset = displayPair[0];
    const secondAsset = displayPair[1];

    return (
        <div
            className={cn(
                "col-span-2 bg-card border border-card-foreground rounded-3xl h-full max-h-full flex w-full flex-col transition-all duration-300 overflow-hidden pb-4",
            )}
        >
            <div className="w-full flex md:flex-row flex-col md:justify-between justify-start gap-4 p-5 ">
                <div className={"flex flex-col gap-2 md:col-span-1"}>
                    <div className={"text-3xl flex gap-3 items-center"}>
                        <span>{formattedPrice.slice(0, 7)}</span>
                        <div className="flex items-center gap-2">
                            {/* First Asset */}
                            {firstAsset && <AssetButton asset={firstAsset} seletable={false} />}

                            {/* Separator */}
                            <span className="text-accent">/</span>

                            {/* Second Asset */}
                            {secondAsset && <AssetButton asset={secondAsset} seletable={false} />}
                        </div>
                    </div>
                    <div className={cn("text-accent flex gap-2 items-center")}>
                        <span className={cn(priceChange >= 0 ? "text-green-500" : "text-red-500")}>
                            {formattedPriceChange}
                        </span>
                        <span>Last hour</span>
                    </div>
                </div>

                <TimeSwitch />
            </div>

            {children}
        </div>
    );
};

export default ViewHolder;
